import { request } from "@/utils/request";

/**
 * 查询操作日志
 * @param {*} data
 * @returns
 */
export function selectApi(data) {
  return request({
    url: `/admin/log/select`,
    method: "POST",
    data,
  });
}
